// src/constants/PropertyFieldDropdowns.jsx
// Single source of truth for every property field dropdown in the project.
// Values must match what is stored in Proeprty-Details, otherwise an edited
// listing stops matching the search filters in FilterPage.

export const PROPERTY_TYPES = [
  "Residential Rent",
  "Residential Sell",
  "Commercial Rent",
  "Commercial Sell",
];

export const RESIDENTIAL_UNIT_TYPES = [
  "Apartment",
  "Bungalow",
  "Tenement",
  "Penthouse",
  "Weekend Home",
  "Rowhouse",
  "Residential Plot",
  "PG",
  "Pre Leased Spaces",
];

export const COMMERCIAL_UNIT_TYPES = [
  "Office",
  "Shop",
  "Showroom",
  "Godown",
  "Ware House",
  "Factory",
  "Co Working Space",
  "Commercial Building",
  "Commercial Flat",
  "Commericial Bunglow",
  "Restaurant",
  "Cafe",
  "Hotel",
  "Hospital",
  "Gym",
  "Spa",
  "Salon",
  "Petrol Pump",
  "Industrial Land",
  "Agriculture Land",
  "Land",
  "PG House",
  "Pre Leased Spaces",
];

export const BHK_OPTIONS = [
  "Studio Apartment",
  "1 BHK",
  "2 BHK",
  "3 BHK",
  "4 BHK",
  "5 BHK",
  "6 BHK",
  "6+ BHK",
];

export const FURNISHED_OPTIONS = [
  "Furnished",
  "Semi-Furnished",
  "Kitchen-Fix",
  "Unfurnished",
];

export const FACING_OPTIONS = [
  "East",
  "West",
  "North",
  "South",
  "North-East",
  "North-West",
  "South-East",
  "South-West",
];

export const TENANT_OPTIONS = [
  "Only For Family",
  "Only For Bachelors",
  "Family-Bachelors",
];

export const AGE_OPTIONS = [
  "1-5 Years",
  "5-10 Years",
  "10-15 Years",
  "15-20 Years",
  "20-25 Years",
  "25-30 Years",
  "30-35 Years",
  "35-40 Years",
  "40-45 Years",
  "45-50 Years",
  "50 & Above",
  "Newly Constructed",
];

export const WASHROOM_TYPES = ["Common Washroom", "Attached Washroom"];

export const BROKERAGE_OPTIONS = [
  "Half brokerage",
  "Full brokerage",
  "No brokerage",
];

export const PARKING_OPTIONS = ["Common Parking", "Alloted Parking"];

export const OCCUPANCY_OPTIONS = ["Family", "Bachelor", "Any"];

export const CURRENT_STATUS_OPTIONS = ["Active", "Rent out", "Sell out"];

// Mirrors CustomDropdown.js: the closing option differs for sell vs rent.
export const SELL_STATUS_OPTIONS = [
  "Active",
  "Not Answer",
  "Sell out",
  "Data Mismatch",
  "Broker",
  "Duplicate",
];

export const RENT_STATUS_OPTIONS = [
  "Active",
  "Not Answer",
  "Rent out",
  "Data Mismatch",
  "Broker",
  "Duplicate",
];

const isSellType = (type) => String(type || "").toLowerCase().includes("sell");
const isCommercialType = (type) => String(type || "").toLowerCase().includes("commercial");

/** Unit types available for a property type. */
export const getUnitTypeOptions = (type) =>
  isCommercialType(type) ? COMMERCIAL_UNIT_TYPES : RESIDENTIAL_UNIT_TYPES;

/** Status list for a property type. */
export const getStatusOptions = (type) =>
  isSellType(type) ? SELL_STATUS_OPTIONS : RENT_STATUS_OPTIONS;

/**
 * Keep a stored value selectable even when it is not in our option list,
 * so opening an edit form never silently blanks an existing field.
 */
export const withCurrentValue = (options, value) =>
  value && !options.includes(value) ? [value, ...options] : options;
